<template>
  <section>
    <div class="mgb-24 detail-card-intro">
      <div class="mdc-card__primary-action1" tabindex="0">
        <div class="mgt-36 mgb-20">
          <div id="htmlDoc" :class="{'withgradient': !showButton && !isToggle}" class="htmlWrapper t-body1 t-color-bodyGrayA font-r t-line-h-26">
            <div :class="{'overflow-hidden': !isToggle}" :style="{height: htmlDataHeight + 'px'}" class="html-container" v-html="introduction">
            </div>
          </div>
          <div v-show="!showButton" class="d-flex justify-content-center flex-grow-1 gradient-bg">
            <div class="position-relative mdc-menu-anchor menu-container mgr-16 h-36 d-flex align-items-center">
              <button class="mdc-button mdc-button--icon-leading js--dropdown-toggle mgr--8 pdl-24 pdr-12 menu-button-with-border cursor-pointer" @click="toggleMore" @keypress="toggleMore">
                <span id="rippleId" class="mdc-button__ripple"></span>
                <span class="t-body3 font-r t-color-bodyGrayA pdr-8 d-inline-block t-nowrap">
                    {{ !isToggle ? $t('30111') : $t('30112') }}
                  </span>
                <i class="material-icons t-color-bodyGrayA dropdownIcon" v-html="!isToggle ? 'arrow_drop_down' : 'arrow_drop_up'"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {MDCRipple} from "@material/ripple";

export default {
  name: "Intro",

  props: ['introduction'],

  data() {
    return {
      isToggle: false,
      fixedHeight: 500,
      htmlDataHeight: null,
      showButton: false,
      vHtmlHeight: null,
      intervalId: null
    }
  },

  created() {
    this.intervalId = setInterval( () => {
      const newHeight = this.calcHeight();
      if (newHeight !== this.vHtmlHeight) {
        this.vHtmlHeight = newHeight;
        clearInterval(this.intervalId);
      }
    }, 500);
  },

  mounted() {
    this.setMaterialUi();
  },

  beforeDestroy() {
    clearInterval(this.intervalId);
  },

  methods: {
    calcHeight() {
        const htmlContainer = document.querySelector('.html-container');
        const imgTags = htmlContainer.querySelectorAll('p img:first-child');
        let totalHeight;
        let imgHeight = 0;
        let hasNonImgContent = false;

        imgTags.forEach((img) => {
          if (img.parentNode.childNodes.length === 1 && img.parentNode.tagName.toLowerCase() === 'p') {
            imgHeight += img.scrollHeight;
          } else {
            hasNonImgContent = true;
          }
        });

        if (hasNonImgContent) {
          totalHeight = htmlContainer.scrollHeight;
        } else {
          totalHeight = htmlContainer.scrollHeight + imgHeight;
        }
        this.htmlDataHeight = Math.min(totalHeight, this.fixedHeight);
        this.showButton = totalHeight <= this.fixedHeight;
      return totalHeight;
    },

    async toggleMore() {
      this.htmlDataHeight = (this.isToggle ?  this.fixedHeight : this.vHtmlHeight);
      document.querySelector('.html-container').style.height = this.htmlDataHeight;
      this.isToggle = !this.isToggle;
    },

    setMaterialUi() {
      const buttonRipple = [].map.call(
          document.querySelectorAll(".mdc-button"),
          function (el) {
            let button = new MDCRipple.attachTo(el);
            return button;
          }
      );
    }
  }
}
</script>

<style scoped>
#htmlDoc >>> i {
  font-style: italic;
}

#htmlDoc >>> img {
  margin: auto;
  width: auto;
  display: block;
}

#htmlDoc >>> p {
  margin-block-start: 0px;
  margin-block-end: 0px;
}

#rippleId {
  border-radius: 16px !important;
}

</style>

<style lang="css" scoped src="../../../css/bootstrap.css">
</style>
